// app/(app)/reports/index.tsx
import { useAppTheme } from "@/hooks/useAppTheme";
import { Ionicons } from "@expo/vector-icons";
import { router } from "expo-router";
import { StyleSheet, Text, TouchableOpacity, View } from "react-native";

export default function ReportsMenuScreen() {
  const { colors, spacing } = useAppTheme();

  const styles = StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: colors.background,
      padding: spacing.lg,
    },
    title: {
      fontSize: 28,
      fontWeight: "700",
      color: colors.text,
      marginBottom: spacing.xl,
    },
    menuCard: {
      backgroundColor: colors.background,
      borderRadius: 16,
      padding: spacing.lg,
      marginBottom: spacing.md,
      borderWidth: 1,
      borderColor: colors.border,
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
    },
    menuLeft: {
      flexDirection: "row",
      alignItems: "center",
      gap: spacing.md,
    },
    iconContainer: {
      width: 48,
      height: 48,
      borderRadius: 24,
      backgroundColor: colors.primary + "15",
      justifyContent: "center",
      alignItems: "center",
    },
    menuTitle: {
      fontSize: 18,
      fontWeight: "600",
      color: colors.text,
      marginBottom: 4,
    },
    menuDesc: {
      fontSize: 14,
      color: colors.textLight,
    },
    chevron: {
      color: colors.textLight,
    },
  });

  const reports = [
    {
      id: "sales",
      title: "Sales Report",
      description: "View sales summary and invoice details",
      icon: "bar-chart-outline",
      route: "/(app)/reports/sales",
    },
    {
      id: "product-requirement",
      title: "Product Requirement",
      description: "Check stock requirements",
      icon: "cube-outline",
      route: "/(app)/reports/product-requirement",
    },
    {
      id: "stock-value",
      title: "Stock Value Report",
      description: "Current stock quantities and total value",
      icon: "cube-outline",
      route: "/(app)/reports/stock-value",
    },
    {
      id: "payments",
      title: "Payment Report",
      description: "View payment summary and details",
      icon: "cash-outline",
      route: "/(app)/reports/payments",
    },
    {
      id: "returns",
      title: "Return Report",
      description: "View return requests with status and amounts",
      icon: "arrow-undo-outline",
      route: "/(app)/reports/returns",
    },
    {
      id: "stock-addition",
      title: "Stock Addition Report",
      description: "Download PDF of all stock‑in transactions",
      icon: "add-circle-outline",
      route: "/(app)/reports/stock-addition",
    },
  ];

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Reports</Text>

      {reports.map((report) => (
        <TouchableOpacity
          key={report.id}
          style={styles.menuCard}
          onPress={() => router.push(report.route as any)}
        >
          <View style={styles.menuLeft}>
            <View style={styles.iconContainer}>
              <Ionicons
                name={report.icon as any}
                size={24}
                color={colors.primary}
              />
            </View>
            <View>
              <Text style={styles.menuTitle}>{report.title}</Text>
              <Text style={styles.menuDesc}>{report.description}</Text>
            </View>
          </View>
          <Ionicons name="chevron-forward" size={20} color={colors.textLight} />
        </TouchableOpacity>
      ))}
    </View>
  );
}
